import { sec } from './units.ts';

/*
 * Vela, the Archer without arrows (scout; docs/ANTIHEROES.md, "Los siete que faltan"): she ran out of arrows on the
 * wall walk and kept watching. The titan dreams her shooting smoke off an empty string. She punishes standing still
 * and bunching up. Her damage to heroes, as every Unsleeping's, is at least a share of the hero's own health,
 * through armour and shields.
 */
export const VELA = {
  /** Her shots reach this far; she stands and shoots while a hero is in it. */
  range: 6500,
  /** Each shot: at least this share of the struck hero's max health. */
  blowMaxHpBp: 700,
  /** Eye of the wall walk: each shot goes on through every hero behind the target, within `width` of its line, to her range. */
  pierce: { width: 550 },
  /** …and lands `bp` on a hero that didn't move in the last `ticks`. */
  still: { ticks: sec(1), bp: 15000 },
  /** Smoke arrow: a long line through every hero on it; the struck stay smoked `ticks` (nightmares hit them `takenBp`). */
  arrow: { every: sec(6), range: 9500, width: 650, damage: 40, maxHpBp: 600, ticks: sec(5) },
  /** What a nightmare's blow (not an Unsleeping's) comes to on a smoked hero. */
  smokedTakenBp: 13000,
  /**
   * Leap back: a hero closer than `near`, and she leaps `far` away from it in `step`s, leaving black roots where she
   * stood. One charge, recharging every `every`; two charges from her second phase.
   */
  leap: { every: sec(12), near: 1800, far: 4000, step: 500, charges: [1, 2, 2] as readonly number[] },
  /** Black roots: armed after `arm`, the first heroes on them are held `hold` (her control: once per immunity) and hurt; gone after `ticks`. */
  roots: { radius: 700, arm: 3, ticks: sec(10), hold: sec(1.5), damage: 30, maxHpBp: 500 },
  /**
   * Endless rain (ultimate): a big circle on the tightest group within `range` (two smaller on two groups from her
   * last phase). Once it lands, arrows fall every `every` for `ticks`: each volley at least `maxHpBp` of a hero's
   * health (staying in is falling) and `towerBp` of a tower's.
   */
  rain: { range: 10000, radius: 3000, smallRadius: 2100, apart: 3000, ticks: sec(4), every: sec(0.5), damage: 40, maxHpBp: 1400, towerBp: 700 },
};
